import { Res } from 'core/api';
import { Message } from 'core/ui-next/modal';
import { CashdrawerFacade } from 'pos/facades';

export default async function deleteTrainingActivity(): Promise<boolean> {

	const isThereTrainingActivity = await CashdrawerFacade.isThereTrainingActivity();
	if (!isThereTrainingActivity)
		return true;

	const { ok } = await Message.confirm(Res.Msg.MSG_DELETE_TRAINING_ACTIVITY_TO_CLOSE_DAY());
	if (!ok)
		return false;

	await CashdrawerFacade.deleteTrainingActivity();
	return true;
}
